import {ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {PredefinedNoteSetDataModel} from '../../../models/notes/predefined-note-set-data.model';
import {OrderChangeModel} from '../../../models/ui/OrderChangeModel';
import {MatCheckbox} from '@angular/material/checkbox';
import {TdoSearchEvent} from '../../../tdo-controls/common/tdo-search/models/TdoSearchEvent';
import {TdoImagingImageContainerComponent} from '../tdo-imaging-image-container/tdo-imaging-image-container.component';
import {FileManagerService} from '../../../modules/file-manager/file-manager.service';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {EditEnumDialogComponent} from "../../../dialog/edit-enum-dialog/edit-enum-dialog.component";

@Component({
  standalone: false,
  selector: 'app-imaging-categories-menu',
  templateUrl: './imaging-categories-menu.component.html',
  styleUrls: ['./imaging-categories-menu.component.scss']
})
export class ImagingCategoriesMenuComponent implements OnInit {
  @Input() dropdownMenuYOffset: string;
  @Input() dropdownMenuXOffset: string;
  @Input() selectedContainer: TdoImagingImageContainerComponent;
  @Input() isStaticMode: boolean = false;
  @Input() height = '86dvh';

  @Output() categoriesSelected = new EventEmitter<EnumValidValueItemModel[]>();

  allCategories: EnumValidValueItemModel[] = [];
  categories: EnumValidValueItemModel[] = [];
  favoritesIds: string[] = [];
  favorites: EnumValidValueItemModel[] = [];
  selectedCategories: EnumValidValueItemModel[] = [];

  isShowMenu: boolean = false;
  isInitialized = false;
  isTagDeselected: boolean = false;

  constructor(private fileManagerService: FileManagerService,
              private dialog: MatDialog,
              private staticDataService: StaticDataService,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.isStaticMode) {
      this.isShowMenu = true;
    }

    if (this.staticDataService.isReady) {
      this.allCategories = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag');
      this.getFavorites();
      this.isInitialized = true;
      this.cdr.markForCheck();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.allCategories = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag');
          this.getFavorites();
          this.isInitialized = true;
          this.cdr.markForCheck();
        },
        error: () => {
          this.isInitialized = true;
          this.cdr.markForCheck();
        }
      });
    }
  }

  private getFavorites() {
    this.allCategories = this.allCategories.sort((a, b) => {
      return (a.ItemDisplayValue < b.ItemDisplayValue) ? -1 : (a.ItemDisplayValue > b.ItemDisplayValue) ? 1 : 0;
    });
    const favs = localStorage.getItem('document-tag-favorites');
    this.favoritesIds = JSON.parse(favs) as string[];
    if (!favs) {
      this.favoritesIds = [];
    }
    this.filterFavorites();
  }

  private saveFavorites(ids: string[]) {

  }

  filterFavorites() {
    this.favorites = this.allCategories.filter(p => this.favoritesIds.includes(p.ValidValueItemId));
    this.categories = this.allCategories.filter(p => !this.favoritesIds.includes(p.ValidValueItemId));
  }

  onMenuClick() {
    if (this.isStaticMode) {
      return;
    }

    this.isShowMenu = !this.isShowMenu;

    if (!this.isShowMenu) {
      if (this.selectedCategories.length > 0) {
        this.categoriesSelected.emit(this.selectedCategories);
      }
    } else {
      this.selectedCategories = this.selectedContainer.document.dataDocumentTags.concat().map(p => p.enumDocumentTag);
    }
  }

  onClickOutside() {
    if (this.isStaticMode) {
      return;
    }

    if (this.selectedCategories.length > 0 && this.isShowMenu) {
      this.categoriesSelected.emit(this.selectedCategories);
    }

    this.isShowMenu = false;
  }

  sectionDrop(event: CdkDragDrop<PredefinedNoteSetDataModel>) {
    moveItemInArray(this.categories, event.previousIndex, event.currentIndex );

  }

  onTagClick(cat: EnumValidValueItemModel, cb: MatCheckbox) {

    this.isTagDeselected = false;
    const idx1 = this.selectedCategories.findIndex(p => p.ValidValueItemId === cat.ValidValueItemId);
      if (idx1 > -1) {
        this.isTagDeselected = true;
        cb.checked = false;
        this.selectedCategories.splice(idx1, 1);

        const selectedTagIds = this.selectedCategories.map(p => p.ValidValueItemId);
        const currentTags = this.selectedContainer.document.dataDocumentTags;
        const currentTagIds = currentTags.map(p => p.enumDocumentTagID);

        const tagsToDelete = currentTagIds.filter(p => !selectedTagIds.includes(p));
        if (tagsToDelete.length > 0) {
          this.fileManagerService.removeDocumentTags(this.selectedContainer.document.DocumentID, null, tagsToDelete).subscribe((res) => {
            this.selectedContainer.document.dataDocumentTags = res;
            const idx = this.selectedContainer.document.dataDocumentTags.findIndex(p => p.DocumentTagID === tagsToDelete[0]);
            if (idx > -1) {
              this.selectedContainer.document.dataDocumentTags.splice(idx, 1);
            }

          });
        }
      }
      else {
        this.selectedCategories.push(cat);
        cb.checked = true;
      }


    if (this.isStaticMode) {
      this.categoriesSelected.emit(this.selectedCategories);
    }
  }

  addToFavorites() {
    if (this.selectedCategories.length > 0) {
      for (const sel of this.selectedCategories) {
        if (!this.favorites.includes(sel)) {
          this.favorites.push(sel);
        }
      }

      this.favoritesIds = this.favorites.map(p => p.ValidValueItemId);
      localStorage.setItem('document-tag-favorites', JSON.stringify(this.favoritesIds));
      this.categories = this.allCategories.filter(p => !this.favoritesIds.includes(p.ValidValueItemId));
      this.selectedCategories = [];
    }
  }

  removeFromFavorites() {
    if (this.selectedCategories.length > 0) {
      const ids = this.selectedCategories.map(p => p.ValidValueItemId);
      this.favorites = this.favorites.filter(p => !ids.includes(p.ValidValueItemId));
      const idsToSave = this.favorites.map(p => p.ValidValueItemId);
      localStorage.setItem('document-tag-favorites', JSON.stringify(idsToSave));
      this.selectedCategories = [];
    }
  }

  onEditClick(e)  {

    console.log("claik on all");

    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.categories;

    this.dialog.open(EditEnumDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.categories = [];

        setTimeout(() => {
          this.categories = res;
          //this.datasource = this.categories;
        }, 100);
      }
    });


  }

  onSearch(event: TdoSearchEvent) {
    this.categories = this.allCategories.filter(p => !this.favoritesIds.includes(p.ValidValueItemId) && p.ItemDisplayValue.toLowerCase().includes(event.value.toLowerCase()));
  }

  onSearchCleared(event: any) {
    this.categories = this.allCategories.filter(p => !this.favoritesIds.includes(p.ValidValueItemId));
  }

  isChecked(cat: EnumValidValueItemModel, cb: MatCheckbox) {
    if (this.isStaticMode) {
      return null;
    }
    if (this.selectedContainer && this.selectedContainer.document) {
      const match = this.selectedContainer.document.dataDocumentTags.find(p => p.enumDocumentTagID.toLowerCase() === cat.ValidValueItemId.toLowerCase());
      if (match) {
        if (cb) {
          cb.checked = true;
        }
        return true;
      }
    }
    /*if (cb) {
      cb.checked = false;
    }*/
    return false;
  }

  onMouseWheel(event: any, categories: HTMLDivElement) {
    categories.scrollLeft += event.deltaY * 2;
    if (event.deltaY > 0) {
      // Scrolled down

    } else {
      // Scrolled up
    }
  }
}
